import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const Footer = () => {
  const footerStyle = {
    background: 'linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%)',
    color: 'var(--gray-800)',
    padding: '4rem 0 2rem 0',
    marginTop: '4rem',
    position: 'relative',
    overflow: 'hidden',
    borderTop: '1px solid var(--gray-200)'
  };

  const footerTopStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '3rem',
    marginBottom: '3rem'
  };

  const footerBottomStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '2rem 1rem 0 1rem',
    borderTop: '1px solid var(--gray-300)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '1rem'
  };

  const columnStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  };

  const headingStyle = {
    fontSize: '1.25rem',
    fontWeight: 600,
    marginBottom: '1rem',
    color: 'var(--primary-green)'
  };

  const linkStyle = {
    color: 'var(--gray-600)',
    textDecoration: 'none',
    fontSize: '0.95rem',
    transition: 'all 0.3s ease',
    padding: '0.25rem 0'
  };

  const socialLinksStyle = {
    display: 'flex',
    gap: '1rem',
    marginTop: '1rem'
  };

  const socialLinkStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    background: 'var(--primary-green)',
    borderRadius: '50%',
    color: 'white',
    textDecoration: 'none',
    transition: 'all 0.3s ease'
  };

  const decorativePattern = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.02'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
    pointerEvents: 'none'
  };

  return (
    <footer style={footerStyle}>
      <div style={decorativePattern}></div>

      <div style={footerTopStyle}>
        {/* Company Info */}
        <div style={columnStyle}>
          <Logo size="small" />
          <p style={{ color: 'var(--gray-600)', lineHeight: 1.6, marginTop: '1rem' }}>
            Empowering businesses through innovative SaaS solutions.
            We deliver scalable, secure, and user-friendly software
            that drives growth and efficiency.
          </p>
          <div style={socialLinksStyle}>
            <a
              href="#"
              style={socialLinkStyle}
              onMouseEnter={(e) => {
                e.target.style.background = 'var(--primary-green-dark)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'var(--primary-green)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
              </svg>
            </a>
            <a
              href="#"
              style={socialLinkStyle}
              onMouseEnter={(e) => {
                e.target.style.background = 'var(--primary-green-dark)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'var(--primary-green)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
            <a
              href="#"
              style={socialLinkStyle}
              onMouseEnter={(e) => {
                e.target.style.background = 'var(--primary-green-dark)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'var(--primary-green)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.404-5.965 1.404-5.965s-.359-.717-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.749.099.12.112.225.083.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.746-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div style={columnStyle}>
          <h4 style={headingStyle}>Quick Links</h4>
          <Link
            to="/"
            style={linkStyle}
            onMouseEnter={(e) => {
              e.target.style.color = 'var(--primary-green)';
              e.target.style.paddingLeft = '0.5rem';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'var(--gray-600)';
              e.target.style.paddingLeft = '0';
            }}
          >
            Home
          </Link>
          <Link
            to="/about"
            style={linkStyle}
            onMouseEnter={(e) => {
              e.target.style.color = 'var(--primary-green)';
              e.target.style.paddingLeft = '0.5rem';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'var(--gray-600)';
              e.target.style.paddingLeft = '0';
            }}
          >
            About Us
          </Link>
          <Link
            to="/solutions"
            style={linkStyle}
            onMouseEnter={(e) => {
              e.target.style.color = 'var(--accent-cyan)';
              e.target.style.paddingLeft = '0.5rem';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'rgba(255, 255, 255, 0.8)';
              e.target.style.paddingLeft = '0';
            }}
          >
            Our Solutions
          </Link>
          <Link
            to="/why-us"
            style={linkStyle}
            onMouseEnter={(e) => {
              e.target.style.color = 'var(--accent-cyan)';
              e.target.style.paddingLeft = '0.5rem';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'rgba(255, 255, 255, 0.8)';
              e.target.style.paddingLeft = '0';
            }}
          >
            Why Choose Us
          </Link>
          <Link
            to="/contact"
            style={linkStyle}
            onMouseEnter={(e) => {
              e.target.style.color = 'var(--accent-cyan)';
              e.target.style.paddingLeft = '0.5rem';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'rgba(255, 255, 255, 0.8)';
              e.target.style.paddingLeft = '0';
            }}
          >
            Contact
          </Link>
        </div>

        {/* Services */}
        <div style={columnStyle}>
          <h4 style={headingStyle}>Services</h4>
          <span style={linkStyle}>Custom Solutions</span>
          <span style={linkStyle}>AI Workflows & Automation</span>
          <span style={linkStyle}>Trading Applications</span>
          <span style={linkStyle}>Investment Automation</span>
          <span style={linkStyle}>Bespoke Development</span>
        </div>

        {/* Contact Info */}
        <div style={columnStyle}>
          <h4 style={headingStyle}>Contact Info</h4>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--gray-600)' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
            </svg>
            <span style={{ fontSize: '0.9rem' }}>30 N Gould St Ste N, Sheridan, WY 82801</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--gray-600)' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
            </svg>
            <span style={{ fontSize: '0.9rem' }}>info@vissdatech.com</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--gray-600)' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
            </svg>
            <span style={{ fontSize: '0.9rem' }}>+995 595051875</span>
          </div>
        </div>
      </div>

      <div style={footerBottomStyle}>
        <p style={{ color: 'var(--gray-500)', fontSize: '0.9rem' }}>
          &copy; {new Date().getFullYear()} VissdaTech. All rights reserved.
        </p>
        <div style={{ display: 'flex', gap: '2rem' }}>
          <a href="#" style={{ ...linkStyle, fontSize: '0.9rem' }}>Privacy Policy</a>
          <a href="#" style={{ ...linkStyle, fontSize: '0.9rem' }}>Terms of Service</a>
          <a href="#" style={{ ...linkStyle, fontSize: '0.9rem' }}>Cookie Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;